import extension from "extensions"
import { rest } from "msw"

const oktaOauthURL =
  extension.config?.oktaConfig?.URL + "oauth2/default/v1/userinfo"
const ticketURL = extension.config?.ticketingApiGateway?.URL + "/tickets"
export default [
  rest.post(ticketURL, (req, res, ctx) => {
    const resBody = {
      id: "123456",
      type: "task",
      subject: "subject",
      status: "new",
      extra: ""
    }
    return res(ctx.status(201), ctx.json(resBody))
  }),
  rest.get(oktaOauthURL, (req, res, ctx) => {
    const resBody = {
      sub: "00udhk4v9fcg1G5UY0h7",
      name: "Colin Burgess",
      locale: "en-US",
      email: "cjburgess@deloitte.co.uk",
      preferred_username: "cjburgess@deloitte.co.uk",
      given_name: "Colin",
      family_name: "Burgess",
      zoneinfo: "America/Los_Angeles",
      updated_at: 1594041188,
      email_verified: true
    }

    return res(ctx.status(200), ctx.json(resBody))
  })
]
